import { Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { YesNoTag } from 'business/quality-control/pages/defect-report-history/components/yes-no-tag';
import { formatDateWithMiddleDot } from 'technical/format/date';

import styles from './index.module.scss';

const { Text } = Typography;

export const CardDetails = ({
  title,
  date,
  author,
  comment,
  toRepair,
  indicator,
  hasBorder,
}: {
  title: string;
  date: string;
  author: string | null;
  comment: string | null;
  toRepair?: boolean | null;
  // undefined hides the field, null displays an empty value
  indicator?: string | null;
  hasBorder?: boolean;
}) => {
  const { t } = useTranslation();

  const formattedMeta = author
    ? t('qualityControl.ringComplianceReport.detail.body.sectionByAuthor', {
        datetime: formatDateWithMiddleDot(date),
        author: author,
      })
    : formatDateWithMiddleDot(date);

  return (
    <div
      className={`${styles.section}${hasBorder ? ` ${styles.sectionWithBorder}` : ''}`}
    >
      <Flex vertical>
        <Text type="secondary">{title}</Text>
        <Text strong>{formattedMeta}</Text>
      </Flex>
      <Flex gap={32}>
        {toRepair != undefined && (
          <Flex vertical>
            <Text type="secondary">
              {t('qualityControl.defectReportHistory.toRepair')}
            </Text>
            <div>
              <YesNoTag value={toRepair} />
            </div>
          </Flex>
        )}
        {indicator !== undefined && (
          <Flex vertical>
            <Text type="secondary">
              {t('qualityControl.defectReportHistory.indicator')}
            </Text>
            <Text strong>{indicator ?? '-'}</Text>
          </Flex>
        )}
      </Flex>
      <Flex vertical>
        <Text type="secondary">
          {t('qualityControl.ringComplianceReport.detail.body.comment')}
        </Text>
        <Text strong>{comment ?? '-'}</Text>
      </Flex>
    </div>
  );
};
